module.exports = __webpack_public_path__ + "front/img/72.95603ce2.png";